import React from 'react';
import { Helmet } from 'react-helmet';

function Header() {
  return (
    <Helmet>
      <meta name='description' content='Software Developer/Engineer open for new career opportunities ' />
      <meta
        name='keywords'
        content='Gab Agoncillo, Gabriel Agoncillo, Gab Agoncillo Netlify, Gabriel Agoncillo Netlify, gab agoncillo, gabriel agoncillo, gab agoncillo netlify, gabriel agoncillo netlify, gab, gab netlify, gabriel, gabriel netlify, agoncillo'
      />
      <meta name='author' content='Gab Agoncillo' />
      <meta name='robots' content='index,follow' />
    </Helmet>
  );
}

export default Header;
